// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file backoffice/v1/backoffice.proto (package backoffice.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BookingStatus } from "../../booking/v1/booking_pb";
import { file_booking_v1_booking } from "../../booking/v1/booking_pb";
import type { CaseStatus } from "../../case/v1/case_pb";
import { file_case_v1_case } from "../../case/v1/case_pb";
import type { Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { GuaranteeType } from "../../mission/v1/guarantee_pb";
import { file_mission_v1_guarantee } from "../../mission/v1/guarantee_pb";
import type { Price, TransportType } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file backoffice/v1/backoffice.proto.
 */
export const file_backoffice_v1_backoffice: GenFile = /*@__PURE__*/
  fileDesc("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", [file_booking_v1_booking, file_case_v1_case, file_google_protobuf_struct, file_google_protobuf_timestamp, file_mission_v1_guarantee, file_mobility_v1_common]);

/**
 * SyncMissionBookingsRequest - the mission whose booking items to re-fetch.
 *
 * @generated from message backoffice.v1.SyncMissionBookingsRequest
 */
export type SyncMissionBookingsRequest = Message<"backoffice.v1.SyncMissionBookingsRequest"> & {
  /**
   * Mission identifier.
   *
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message backoffice.v1.SyncMissionBookingsRequest.
 * Use `create(SyncMissionBookingsRequestSchema)` to create a new message.
 */
export const SyncMissionBookingsRequestSchema: GenMessage<SyncMissionBookingsRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 0);

/**
 * SyncMissionBookingsResponse - outcome of a sync. An item its provider failed to return keeps its
 * last known state.
 *
 * @generated from message backoffice.v1.SyncMissionBookingsResponse
 */
export type SyncMissionBookingsResponse = Message<"backoffice.v1.SyncMissionBookingsResponse"> & {
  /**
   * Booking items refreshed from their provider.
   *
   * @generated from field: repeated string synced_item_ids = 1;
   */
  syncedItemIds: string[];

  /**
   * Booking items their provider failed to return.
   *
   * @generated from field: repeated string failed_item_ids = 2;
   */
  failedItemIds: string[];
};

/**
 * Describes the message backoffice.v1.SyncMissionBookingsResponse.
 * Use `create(SyncMissionBookingsResponseSchema)` to create a new message.
 */
export const SyncMissionBookingsResponseSchema: GenMessage<SyncMissionBookingsResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 1);

/**
 * GetMissionIndicatorsRequest - the mission to measure.
 *
 * @generated from message backoffice.v1.GetMissionIndicatorsRequest
 */
export type GetMissionIndicatorsRequest = Message<"backoffice.v1.GetMissionIndicatorsRequest"> & {
  /**
   * Mission identifier.
   *
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message backoffice.v1.GetMissionIndicatorsRequest.
 * Use `create(GetMissionIndicatorsRequestSchema)` to create a new message.
 */
export const GetMissionIndicatorsRequestSchema: GenMessage<GetMissionIndicatorsRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 2);

/**
 * GetMissionIndicatorsResponse - a mission's metrics, empty for an unknown mission. Costs are
 * external costs in EUR, as on the dashboard.
 *
 * @generated from message backoffice.v1.GetMissionIndicatorsResponse
 */
export type GetMissionIndicatorsResponse = Message<"backoffice.v1.GetMissionIndicatorsResponse"> & {
  /**
   * Distance between the origin and destination searched, as the crow flies, absent without
   * search.
   *
   * @generated from field: optional uint32 distance_meters = 1;
   */
  distanceMeters?: number;

  /**
   * External cost, absent until booked, with an unpriced item or in another currency.
   *
   * @generated from field: mobility.v1.Price external_cost = 2;
   */
  externalCost?: Price;

  /**
   * Cheapest single-taxi solution of the mission's search, absent when none was found.
   *
   * @generated from field: mobility.v1.Price direct_taxi_quote = 3;
   */
  directTaxiQuote?: Price;

  /**
   * Direct taxi quote minus the external cost, absent for a mission made by taxi only or without
   * either amount. Negative when taxi would have been cheaper.
   *
   * @generated from field: mobility.v1.Price savings_vs_taxi = 4;
   */
  savingsVsTaxi?: Price;

  /**
   * Missions created over the last 90 days in the mission's distance band, absent without
   * distance.
   *
   * @generated from field: backoffice.v1.DistanceBand band = 5;
   */
  band?: DistanceBand;
};

/**
 * Describes the message backoffice.v1.GetMissionIndicatorsResponse.
 * Use `create(GetMissionIndicatorsResponseSchema)` to create a new message.
 */
export const GetMissionIndicatorsResponseSchema: GenMessage<GetMissionIndicatorsResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 3);

/**
 * MissionSearchFilter - combinable criteria. Item criteria match a mission when one of its items
 * meets all of them at once.
 *
 * @generated from message backoffice.v1.MissionSearchFilter
 */
export type MissionSearchFilter = Message<"backoffice.v1.MissionSearchFilter"> & {
  /**
   * Exact case number.
   *
   * @generated from field: optional string case_number = 1;
   */
  caseNumber?: string;

  /**
   * Exact mission identifier.
   *
   * @generated from field: optional string mission_id = 2;
   */
  missionId?: string;

  /**
   * Beneficiary first name, case insensitive.
   *
   * @generated from field: optional string beneficiary_first_name = 3;
   */
  beneficiaryFirstName?: string;

  /**
   * Beneficiary last name, case insensitive.
   *
   * @generated from field: optional string beneficiary_last_name = 4;
   */
  beneficiaryLastName?: string;

  /**
   * Vehicle plate, case insensitive.
   *
   * @generated from field: optional string vehicle_plate = 5;
   */
  vehiclePlate?: string;

  /**
   * Beneficiary phone.
   *
   * @generated from field: optional string phone = 6;
   */
  phone?: string;

  /**
   * Missions created at or after this time.
   *
   * @generated from field: optional google.protobuf.Timestamp created_after = 7;
   */
  createdAfter?: Timestamp;

  /**
   * Missions created before this time.
   *
   * @generated from field: optional google.protobuf.Timestamp created_before = 8;
   */
  createdBefore?: Timestamp;

  /**
   * Item statuses, any of.
   *
   * @generated from field: repeated booking.v1.BookingStatus item_statuses = 9;
   */
  itemStatuses: BookingStatus[];

  /**
   * Item transport types, any of.
   *
   * @generated from field: repeated mobility.v1.TransportType transport_types = 10;
   */
  transportTypes: TransportType[];

  /**
   * Exact item provider, as listed by ListProviders.
   *
   * @generated from field: optional string provider = 11;
   */
  provider?: string;

  /**
   * Free text matched against the case number, the beneficiary's names, the vehicle plate and
   * phone (anywhere, case insensitive), and the start of the mission identifier.
   *
   * @generated from field: optional string query = 12;
   */
  query?: string;
};

/**
 * Describes the message backoffice.v1.MissionSearchFilter.
 * Use `create(MissionSearchFilterSchema)` to create a new message.
 */
export const MissionSearchFilterSchema: GenMessage<MissionSearchFilter> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 4);

/**
 * SearchMissionsRequest - a page of a mission search.
 *
 * @generated from message backoffice.v1.SearchMissionsRequest
 */
export type SearchMissionsRequest = Message<"backoffice.v1.SearchMissionsRequest"> & {
  /**
   * Cursor of the page, empty for the first one.
   *
   * @generated from field: string page_cursor = 1;
   */
  pageCursor: string;

  /**
   * Missions per page, 20 by default, 100 at most.
   *
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * Search criteria.
   *
   * @generated from field: backoffice.v1.MissionSearchFilter filter = 3;
   */
  filter?: MissionSearchFilter;

  /**
   * Result order.
   *
   * @generated from field: backoffice.v1.MissionSort sort = 4;
   */
  sort: MissionSort;
};

/**
 * Describes the message backoffice.v1.SearchMissionsRequest.
 * Use `create(SearchMissionsRequestSchema)` to create a new message.
 */
export const SearchMissionsRequestSchema: GenMessage<SearchMissionsRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 5);

/**
 * SearchMissionsResponse - missions grouped by case, in result order. A case can span two pages.
 *
 * @generated from message backoffice.v1.SearchMissionsResponse
 */
export type SearchMissionsResponse = Message<"backoffice.v1.SearchMissionsResponse"> & {
  /**
   * Cases of the page with their matching missions.
   *
   * @generated from field: repeated backoffice.v1.CaseMissions cases = 1;
   */
  cases: CaseMissions[];

  /**
   * Cursor of the next page, empty on the last one.
   *
   * @generated from field: string next_page_cursor = 2;
   */
  nextPageCursor: string;
};

/**
 * Describes the message backoffice.v1.SearchMissionsResponse.
 * Use `create(SearchMissionsResponseSchema)` to create a new message.
 */
export const SearchMissionsResponseSchema: GenMessage<SearchMissionsResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 6);

/**
 * CaseMissions - a case and its missions found by a search.
 *
 * @generated from message backoffice.v1.CaseMissions
 */
export type CaseMissions = Message<"backoffice.v1.CaseMissions"> & {
  /**
   * Case identifier.
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * Case number.
   *
   * @generated from field: string case_number = 2;
   */
  caseNumber: string;

  /**
   * Case status.
   *
   * @generated from field: case.v1.CaseStatus case_status = 3;
   */
  caseStatus: CaseStatus;

  /**
   * Plate of the immobilized vehicle.
   *
   * @generated from field: string vehicle_plate = 4;
   */
  vehiclePlate: string;

  /**
   * Missions of the case found by the search.
   *
   * @generated from field: repeated backoffice.v1.MissionSummary missions = 5;
   */
  missions: MissionSummary[];
};

/**
 * Describes the message backoffice.v1.CaseMissions.
 * Use `create(CaseMissionsSchema)` to create a new message.
 */
export const CaseMissionsSchema: GenMessage<CaseMissions> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 7);

/**
 * MissionSummary - one mission of a search result.
 *
 * @generated from message backoffice.v1.MissionSummary
 */
export type MissionSummary = Message<"backoffice.v1.MissionSummary"> & {
  /**
   * Mission identifier.
   *
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * Mission creation date.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * Guarantee the mission is made under.
   *
   * @generated from field: mission.v1.GuaranteeType guarantee_type = 3;
   */
  guaranteeType: GuaranteeType;

  /**
   * Transport types of the booking items.
   *
   * @generated from field: repeated mobility.v1.TransportType transport_types = 4;
   */
  transportTypes: TransportType[];

  /**
   * ERROR as soon as one item failed, otherwise the least advanced status of the items still
   * tracked online. UNSPECIFIED when the mission has no booking.
   *
   * @generated from field: booking.v1.BookingStatus aggregated_status = 5;
   */
  aggregatedStatus: BookingStatus;

  /**
   * Sum of the item prices, absent without price or when currencies differ.
   *
   * @generated from field: mobility.v1.Price total_amount = 6;
   */
  totalAmount?: Price;

  /**
   * Number of items in error.
   *
   * @generated from field: uint32 failed_item_count = 7;
   */
  failedItemCount: number;

  /**
   * Earliest departure among the items.
   *
   * @generated from field: optional google.protobuf.Timestamp first_departure_at = 8;
   */
  firstDepartureAt?: Timestamp;
};

/**
 * Describes the message backoffice.v1.MissionSummary.
 * Use `create(MissionSummarySchema)` to create a new message.
 */
export const MissionSummarySchema: GenMessage<MissionSummary> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 8);

/**
 * ListProvidersRequest - request for the providers to filter on.
 *
 * @generated from message backoffice.v1.ListProvidersRequest
 */
export type ListProvidersRequest = Message<"backoffice.v1.ListProvidersRequest"> & {
};

/**
 * Describes the message backoffice.v1.ListProvidersRequest.
 * Use `create(ListProvidersRequestSchema)` to create a new message.
 */
export const ListProvidersRequestSchema: GenMessage<ListProvidersRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 9);

/**
 * ListProvidersResponse - providers found on booking items, sorted.
 *
 * @generated from message backoffice.v1.ListProvidersResponse
 */
export type ListProvidersResponse = Message<"backoffice.v1.ListProvidersResponse"> & {
  /**
   * Provider names.
   *
   * @generated from field: repeated string providers = 1;
   */
  providers: string[];
};

/**
 * Describes the message backoffice.v1.ListProvidersResponse.
 * Use `create(ListProvidersResponseSchema)` to create a new message.
 */
export const ListProvidersResponseSchema: GenMessage<ListProvidersResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 10);

/**
 * ListMissionAuditLogsRequest - request for the audit logs of a mission.
 *
 * @generated from message backoffice.v1.ListMissionAuditLogsRequest
 */
export type ListMissionAuditLogsRequest = Message<"backoffice.v1.ListMissionAuditLogsRequest"> & {
  /**
   * Mission identifier.
   *
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message backoffice.v1.ListMissionAuditLogsRequest.
 * Use `create(ListMissionAuditLogsRequestSchema)` to create a new message.
 */
export const ListMissionAuditLogsRequestSchema: GenMessage<ListMissionAuditLogsRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 11);

/**
 * ListMissionAuditLogsResponse - the audit logs of a mission and of its case, oldest first.
 *
 * @generated from message backoffice.v1.ListMissionAuditLogsResponse
 */
export type ListMissionAuditLogsResponse = Message<"backoffice.v1.ListMissionAuditLogsResponse"> & {
  /**
   * Audit logs.
   *
   * @generated from field: repeated backoffice.v1.AuditLog logs = 1;
   */
  logs: AuditLog[];
};

/**
 * Describes the message backoffice.v1.ListMissionAuditLogsResponse.
 * Use `create(ListMissionAuditLogsResponseSchema)` to create a new message.
 */
export const ListMissionAuditLogsResponseSchema: GenMessage<ListMissionAuditLogsResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 12);

/**
 * AuditActor - who performed an audited action.
 *
 * @generated from message backoffice.v1.AuditActor
 */
export type AuditActor = Message<"backoffice.v1.AuditActor"> & {
  /**
   * Kind of actor.
   *
   * @generated from field: backoffice.v1.AuditActorKind kind = 1;
   */
  kind: AuditActorKind;

  /**
   * User identifier, set for a user.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * User email, set for a user still known.
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * User display name, set for a user still known.
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * System actor name, e.g. "taxi_webhook", set for the system.
   *
   * @generated from field: string label = 5;
   */
  label: string;
};

/**
 * Describes the message backoffice.v1.AuditActor.
 * Use `create(AuditActorSchema)` to create a new message.
 */
export const AuditActorSchema: GenMessage<AuditActor> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 13);

/**
 * AuditChange - a field's value before and after an audited action.
 *
 * @generated from message backoffice.v1.AuditChange
 */
export type AuditChange = Message<"backoffice.v1.AuditChange"> & {
  /**
   * Field name.
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * Value before, absent when the field was just set.
   *
   * @generated from field: google.protobuf.Value from = 2;
   */
  from?: Value;

  /**
   * Value after, absent when the field was cleared.
   *
   * @generated from field: google.protobuf.Value to = 3;
   */
  to?: Value;
};

/**
 * Describes the message backoffice.v1.AuditChange.
 * Use `create(AuditChangeSchema)` to create a new message.
 */
export const AuditChangeSchema: GenMessage<AuditChange> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 14);

/**
 * AuditLog - one action performed in the app.
 *
 * @generated from message backoffice.v1.AuditLog
 */
export type AuditLog = Message<"backoffice.v1.AuditLog"> & {
  /**
   * Audit log identifier.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * When the action happened.
   *
   * @generated from field: google.protobuf.Timestamp occurred_at = 2;
   */
  occurredAt?: Timestamp;

  /**
   * Who performed it.
   *
   * @generated from field: backoffice.v1.AuditActor actor = 3;
   */
  actor?: AuditActor;

  /**
   * Action name, e.g. "mission.created", "booking.confirmed".
   *
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * Type of the entity acted on: "case", "mission", "booking" or "booking_item".
   *
   * @generated from field: string entity_type = 5;
   */
  entityType: string;

  /**
   * Identifier of the entity acted on.
   *
   * @generated from field: string entity_id = 6;
   */
  entityId: string;

  /**
   * Fields the action set or changed.
   *
   * @generated from field: repeated backoffice.v1.AuditChange changes = 7;
   */
  changes: AuditChange[];

  /**
   * Why the action was performed, when given.
   *
   * @generated from field: string reason = 8;
   */
  reason: string;

  /**
   * Request that performed the action, to find it in the logs.
   *
   * @generated from field: string request_id = 9;
   */
  requestId: string;
};

/**
 * Describes the message backoffice.v1.AuditLog.
 * Use `create(AuditLogSchema)` to create a new message.
 */
export const AuditLogSchema: GenMessage<AuditLog> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 15);

/**
 * GetDashboardRequest - the period of the dashboard, on mission creation date.
 *
 * @generated from message backoffice.v1.GetDashboardRequest
 */
export type GetDashboardRequest = Message<"backoffice.v1.GetDashboardRequest"> & {
  /**
   * Missions created at or after this time, since the first one when absent.
   *
   * @generated from field: optional google.protobuf.Timestamp created_after = 1;
   */
  createdAfter?: Timestamp;

  /**
   * Missions created before this time, up to now when absent.
   *
   * @generated from field: optional google.protobuf.Timestamp created_before = 2;
   */
  createdBefore?: Timestamp;
};

/**
 * Describes the message backoffice.v1.GetDashboardRequest.
 * Use `create(GetDashboardRequestSchema)` to create a new message.
 */
export const GetDashboardRequestSchema: GenMessage<GetDashboardRequest> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 16);

/**
 * GetDashboardResponse - business metrics of the missions created over the period. Costs are
 * external costs: the price of the items booked with providers, in EUR, missions booked in another
 * currency or with an unpriced item left out.
 *
 * @generated from message backoffice.v1.GetDashboardResponse
 */
export type GetDashboardResponse = Message<"backoffice.v1.GetDashboardResponse"> & {
  /**
   * Volumes of the period.
   *
   * @generated from field: backoffice.v1.DashboardTotals totals = 1;
   */
  totals?: DashboardTotals;

  /**
   * Time from mission creation to booking confirmation, in seconds.
   *
   * @generated from field: backoffice.v1.Distribution handling_time = 2;
   */
  handlingTime?: Distribution;

  /**
   * External cost of a booked mission, in minor units.
   *
   * @generated from field: backoffice.v1.Distribution external_cost = 3;
   */
  externalCost?: Distribution;

  /**
   * Metrics by mission distance, as the crow flies, shortest first.
   *
   * @generated from field: repeated backoffice.v1.DistanceBand distance_bands = 4;
   */
  distanceBands: DistanceBand[];

  /**
   * External cost of booked missions by creation week or month, over the whole period.
   *
   * @generated from field: backoffice.v1.CostTrend external_cost_trend = 5;
   */
  externalCostTrend?: CostTrend;
};

/**
 * Describes the message backoffice.v1.GetDashboardResponse.
 * Use `create(GetDashboardResponseSchema)` to create a new message.
 */
export const GetDashboardResponseSchema: GenMessage<GetDashboardResponse> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 17);

/**
 * CostTrend - median external cost by period: weekly up to 92 days, monthly beyond.
 *
 * @generated from message backoffice.v1.CostTrend
 */
export type CostTrend = Message<"backoffice.v1.CostTrend"> & {
  /**
   * Length of the points' periods.
   *
   * @generated from field: backoffice.v1.TrendGranularity granularity = 1;
   */
  granularity: TrendGranularity;

  /**
   * Every period of the dashboard, oldest first, empty ones included.
   *
   * @generated from field: repeated backoffice.v1.TrendPoint points = 2;
   */
  points: TrendPoint[];
};

/**
 * Describes the message backoffice.v1.CostTrend.
 * Use `create(CostTrendSchema)` to create a new message.
 */
export const CostTrendSchema: GenMessage<CostTrend> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 18);

/**
 * TrendPoint - the costed missions created in one period of a trend.
 *
 * @generated from message backoffice.v1.TrendPoint
 */
export type TrendPoint = Message<"backoffice.v1.TrendPoint"> & {
  /**
   * Start of the period.
   *
   * @generated from field: google.protobuf.Timestamp start = 1;
   */
  start?: Timestamp;

  /**
   * Costed missions created in the period.
   *
   * @generated from field: uint32 missions = 2;
   */
  missions: number;

  /**
   * Median external cost, absent without mission.
   *
   * @generated from field: mobility.v1.Price median_cost = 3;
   */
  medianCost?: Price;

  /**
   * 25th percentile of the external cost, absent without mission.
   *
   * @generated from field: mobility.v1.Price p25_cost = 4;
   */
  p25Cost?: Price;

  /**
   * 75th percentile of the external cost, absent without mission.
   *
   * @generated from field: mobility.v1.Price p75_cost = 5;
   */
  p75Cost?: Price;
};

/**
 * Describes the message backoffice.v1.TrendPoint.
 * Use `create(TrendPointSchema)` to create a new message.
 */
export const TrendPointSchema: GenMessage<TrendPoint> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 19);

/**
 * DashboardTotals - volumes of a dashboard period.
 *
 * @generated from message backoffice.v1.DashboardTotals
 */
export type DashboardTotals = Message<"backoffice.v1.DashboardTotals"> & {
  /**
   * Missions created.
   *
   * @generated from field: uint32 created_missions = 1;
   */
  createdMissions: number;

  /**
   * Missions with at least one item booked.
   *
   * @generated from field: uint32 booked_missions = 2;
   */
  bookedMissions: number;

  /**
   * Missions with at least one item in error.
   *
   * @generated from field: uint32 failed_missions = 3;
   */
  failedMissions: number;

  /**
   * Sum of the external costs of the booked missions.
   *
   * @generated from field: mobility.v1.Price total_external_cost = 4;
   */
  totalExternalCost?: Price;
};

/**
 * Describes the message backoffice.v1.DashboardTotals.
 * Use `create(DashboardTotalsSchema)` to create a new message.
 */
export const DashboardTotalsSchema: GenMessage<DashboardTotals> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 20);

/**
 * Distribution - spread of a metric over missions, in the metric's unit.
 *
 * @generated from message backoffice.v1.Distribution
 */
export type Distribution = Message<"backoffice.v1.Distribution"> & {
  /**
   * Missions measured.
   *
   * @generated from field: uint32 count = 1;
   */
  count: number;

  /**
   * 5th percentile.
   *
   * @generated from field: double p5 = 2;
   */
  p5: number;

  /**
   * Median.
   *
   * @generated from field: double p50 = 3;
   */
  p50: number;

  /**
   * 95th percentile.
   *
   * @generated from field: double p95 = 4;
   */
  p95: number;

  /**
   * 25th percentile.
   *
   * @generated from field: double p25 = 6;
   */
  p25: number;

  /**
   * 75th percentile.
   *
   * @generated from field: double p75 = 7;
   */
  p75: number;

  /**
   * The missions measured, lowest first: all of them up to 300, else 300 of them evenly spread
   * over their ranks.
   *
   * @generated from field: repeated backoffice.v1.MissionValue points = 8;
   */
  points: MissionValue[];

  /**
   * Whether points lists every mission measured.
   *
   * @generated from field: bool points_complete = 9;
   */
  pointsComplete: boolean;
};

/**
 * Describes the message backoffice.v1.Distribution.
 * Use `create(DistributionSchema)` to create a new message.
 */
export const DistributionSchema: GenMessage<Distribution> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 21);

/**
 * MissionValue - one mission's measure in a distribution.
 *
 * @generated from message backoffice.v1.MissionValue
 */
export type MissionValue = Message<"backoffice.v1.MissionValue"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * Creation of the mission.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * The measure, in the distribution's unit.
   *
   * @generated from field: double value = 3;
   */
  value: number;
};

/**
 * Describes the message backoffice.v1.MissionValue.
 * Use `create(MissionValueSchema)` to create a new message.
 */
export const MissionValueSchema: GenMessage<MissionValue> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 22);

/**
 * ModeCount - booked missions of a mode.
 *
 * @generated from message backoffice.v1.ModeCount
 */
export type ModeCount = Message<"backoffice.v1.ModeCount"> & {
  /**
   * Mode.
   *
   * @generated from field: backoffice.v1.MissionMode mode = 1;
   */
  mode: MissionMode;

  /**
   * Missions booked with it.
   *
   * @generated from field: uint32 missions = 2;
   */
  missions: number;
};

/**
 * Describes the message backoffice.v1.ModeCount.
 * Use `create(ModeCountSchema)` to create a new message.
 */
export const ModeCountSchema: GenMessage<ModeCount> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 23);

/**
 * DistanceBand - metrics of the booked missions whose distance falls in [min_km, max_km).
 *
 * @generated from message backoffice.v1.DistanceBand
 */
export type DistanceBand = Message<"backoffice.v1.DistanceBand"> & {
  /**
   * Lower bound in kilometers, included.
   *
   * @generated from field: uint32 min_km = 1;
   */
  minKm: number;

  /**
   * Upper bound in kilometers, excluded, absent for the last band.
   *
   * @generated from field: optional uint32 max_km = 2;
   */
  maxKm?: number;

  /**
   * Booked missions of the band.
   *
   * @generated from field: uint32 booked_missions = 3;
   */
  bookedMissions: number;

  /**
   * Booked missions by mode, most used first.
   *
   * @generated from field: repeated backoffice.v1.ModeCount modes = 4;
   */
  modes: ModeCount[];

  /**
   * Median external cost of a mission, absent without costed mission.
   *
   * @generated from field: mobility.v1.Price median_external_cost = 5;
   */
  medianExternalCost?: Price;

  /**
   * Sum of the external costs.
   *
   * @generated from field: mobility.v1.Price total_external_cost = 6;
   */
  totalExternalCost?: Price;

  /**
   * Share of the booked missions not made by taxi only, from 0 to 1.
   *
   * @generated from field: double modal_shift_rate = 7;
   */
  modalShiftRate: number;

  /**
   * Direct taxi quotes minus the external costs, over the missions not made by taxi only whose
   * search returned a direct taxi quote. Negative when taxi would have been cheaper.
   *
   * @generated from field: mobility.v1.Price savings_vs_taxi = 8;
   */
  savingsVsTaxi?: Price;

  /**
   * Missions the savings are computed on.
   *
   * @generated from field: uint32 savings_missions = 9;
   */
  savingsMissions: number;
};

/**
 * Describes the message backoffice.v1.DistanceBand.
 * Use `create(DistanceBandSchema)` to create a new message.
 */
export const DistanceBandSchema: GenMessage<DistanceBand> = /*@__PURE__*/
  messageDesc(file_backoffice_v1_backoffice, 24);

/**
 * MissionSort - order of a mission search, newest first.
 *
 * @generated from enum backoffice.v1.MissionSort
 */
export enum MissionSort {
  /**
   * Defaults to MISSION_SORT_CREATED_AT_DESC.
   *
   * @generated from enum value: MISSION_SORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * By mission creation date.
   *
   * @generated from enum value: MISSION_SORT_CREATED_AT_DESC = 1;
   */
  CREATED_AT_DESC = 1,

  /**
   * By first departure of the mission's items; missions without departure come last.
   *
   * @generated from enum value: MISSION_SORT_FIRST_DEPARTURE_DESC = 2;
   */
  FIRST_DEPARTURE_DESC = 2,
}

/**
 * Describes the enum backoffice.v1.MissionSort.
 */
export const MissionSortSchema: GenEnum<MissionSort> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 0);

/**
 * AuditActorKind - who performed an audited action.
 *
 * @generated from enum backoffice.v1.AuditActorKind
 */
export enum AuditActorKind {
  /**
   * @generated from enum value: AUDIT_ACTOR_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A signed-in user.
   *
   * @generated from enum value: AUDIT_ACTOR_KIND_USER = 1;
   */
  USER = 1,

  /**
   * The system acting on its own: a provider webhook, a background job.
   *
   * @generated from enum value: AUDIT_ACTOR_KIND_SYSTEM = 2;
   */
  SYSTEM = 2,
}

/**
 * Describes the enum backoffice.v1.AuditActorKind.
 */
export const AuditActorKindSchema: GenEnum<AuditActorKind> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 1);

/**
 * TrendGranularity - length of the periods a trend is split into.
 *
 * @generated from enum backoffice.v1.TrendGranularity
 */
export enum TrendGranularity {
  /**
   * @generated from enum value: TREND_GRANULARITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Weeks starting on Monday, Paris time.
   *
   * @generated from enum value: TREND_GRANULARITY_WEEK = 1;
   */
  WEEK = 1,

  /**
   * Calendar months, Paris time.
   *
   * @generated from enum value: TREND_GRANULARITY_MONTH = 2;
   */
  MONTH = 2,
}

/**
 * Describes the enum backoffice.v1.TrendGranularity.
 */
export const TrendGranularitySchema: GenEnum<TrendGranularity> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 2);

/**
 * MissionMode - the transports a mission was booked with.
 *
 * @generated from enum backoffice.v1.MissionMode
 */
export enum MissionMode {
  /**
   * @generated from enum value: MISSION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Taxi only.
   *
   * @generated from enum value: MISSION_MODE_TAXI = 1;
   */
  TAXI = 1,

  /**
   * Train only.
   *
   * @generated from enum value: MISSION_MODE_TRAIN = 2;
   */
  TRAIN = 2,

  /**
   * Train with taxi ground transfers.
   *
   * @generated from enum value: MISSION_MODE_TRAIN_TAXI = 3;
   */
  TRAIN_TAXI = 3,

  /**
   * A rental vehicle, alone or with other transports.
   *
   * @generated from enum value: MISSION_MODE_RENTAL = 4;
   */
  RENTAL = 4,
}

/**
 * Describes the enum backoffice.v1.MissionMode.
 */
export const MissionModeSchema: GenEnum<MissionMode> = /*@__PURE__*/
  enumDesc(file_backoffice_v1_backoffice, 3);

/**
 * BackofficeService - supervision and support tools for The Treep staff. Every procedure of this
 * package is refused to users who are not platform users.
 *
 * @generated from service backoffice.v1.BackofficeService
 */
export const BackofficeService: GenService<{
  /**
   * Searches missions on their case and on their booking items, grouped by case.
   *
   * @generated from rpc backoffice.v1.BackofficeService.SearchMissions
   */
  searchMissions: {
    methodKind: "unary";
    input: typeof SearchMissionsRequestSchema;
    output: typeof SearchMissionsResponseSchema;
  },
  /**
   * Lists the providers found on booking items, to filter missions on.
   *
   * @generated from rpc backoffice.v1.BackofficeService.ListProviders
   */
  listProviders: {
    methodKind: "unary";
    input: typeof ListProvidersRequestSchema;
    output: typeof ListProvidersResponseSchema;
  },
  /**
   * Lists what was done on a mission and on its case, and by whom, oldest first.
   *
   * @generated from rpc backoffice.v1.BackofficeService.ListMissionAuditLogs
   */
  listMissionAuditLogs: {
    methodKind: "unary";
    input: typeof ListMissionAuditLogsRequestSchema;
    output: typeof ListMissionAuditLogsResponseSchema;
  },
  /**
   * Business metrics of the missions created over a period.
   *
   * @generated from rpc backoffice.v1.BackofficeService.GetDashboard
   */
  getDashboard: {
    methodKind: "unary";
    input: typeof GetDashboardRequestSchema;
    output: typeof GetDashboardResponseSchema;
  },
  /**
   * A mission's metrics placed against the dashboard ones.
   *
   * @generated from rpc backoffice.v1.BackofficeService.GetMissionIndicators
   */
  getMissionIndicators: {
    methodKind: "unary";
    input: typeof GetMissionIndicatorsRequestSchema;
    output: typeof GetMissionIndicatorsResponseSchema;
  },
  /**
   * Re-fetches every booking item of a mission from its provider and saves its current state.
   *
   * @generated from rpc backoffice.v1.BackofficeService.SyncMissionBookings
   */
  syncMissionBookings: {
    methodKind: "unary";
    input: typeof SyncMissionBookingsRequestSchema;
    output: typeof SyncMissionBookingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_backoffice_v1_backoffice, 0);

